import HandPic from './HandPic'

export default HandPic
